var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pagination"
  }, [_c('span', {
    staticClass: "card-box prev iconfont icon-jiantou-zuo",
    class: {
      disabled: _vm.currentPage === 1
    },
    on: {
      "click": function ($event) {
        return _vm.goPrex();
      }
    }
  }, [_c('p', [_vm._v("上一页")])]), _vm._v(" "), _vm.pages <= 5 ? _c('div', {
    staticClass: "pagination-list"
  }, _vm._l(_vm.pages, function (item) {
    return _c('span', {
      key: item,
      staticClass: "card-box",
      class: {
        active: _vm.currentPage === item
      },
      on: {
        "click": function ($event) {
          return _vm.goIndex(item);
        }
      }
    }, [_vm._v(_vm._s(item))]);
  }), 0) : _c('div', {
    staticClass: "pagination-list"
  }, [_c('span', {
    staticClass: "card-box",
    class: {
      active: _vm.currentPage === 1
    },
    on: {
      "click": function ($event) {
        return _vm.goIndex(1);
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage > 3,
      expression: "currentPage > 3"
    }],
    staticClass: "ellipsis ell-two",
    attrs: {
      "title": "上两页"
    },
    on: {
      "click": function ($event) {
        return _vm.goIndex(_vm.currentPage - 2);
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage <= 3,
      expression: "currentPage <= 3"
    }],
    staticClass: "card-box",
    class: {
      active: _vm.currentPage === 2
    },
    on: {
      "click": function ($event) {
        return _vm.goIndex(2);
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "card-box",
    class: {
      active: _vm.currentPage >= 3 && _vm.currentPage <= _vm.pages - 2
    },
    on: {
      "click": function ($event) {
        _vm.goIndex(_vm.threeNum());
      }
    }
  }, [_vm._v(_vm._s(_vm.threeNum()))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage < _vm.pages - 2,
      expression: "currentPage < pages - 2"
    }],
    staticClass: "ellipsis ell-four",
    attrs: {
      "title": "下两页"
    },
    on: {
      "click": function ($event) {
        return _vm.goIndex(_vm.currentPage + 2);
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentPage >= _vm.pages - 2,
      expression: "currentPage >= pages - 2"
    }],
    staticClass: "card-box",
    class: {
      active: _vm.currentPage === _vm.pages - 1
    },
    on: {
      "click": function ($event) {
        return _vm.goIndex(_vm.pages - 1);
      }
    }
  }, [_vm._v(_vm._s(_vm.pages - 1))]), _vm._v(" "), _c('span', {
    staticClass: "card-box",
    class: {
      active: _vm.currentPage === _vm.pages
    },
    on: {
      "click": function ($event) {
        return _vm.goIndex(_vm.pages);
      }
    }
  }, [_vm._v(_vm._s(_vm.pages))])]), _vm._v(" "), _c('span', {
    staticClass: "card-box next iconfont icon-jiantou-you",
    class: {
      disabled: _vm.currentPage === _vm.pages
    },
    on: {
      "click": function ($event) {
        return _vm.goNext();
      }
    }
  }, [_c('p', [_vm._v("下一页")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };